export default __webpack_public_path__ + "static/media/bg.031c22af.png";